import type { GridColumnProps } from "@tql/ui-components-react/kendo/grid";

import type { Invoice } from "~/shared/schemas/invoice-schema.ts";

import { useGetPaymentSummary } from "../../../hooks/use-get-payment-summary.ts";
import { LumpSumPayment } from "../lump-sum-payment/lump-sum-payment.tsx";
import { SelectedInvoicesPayment } from "../selected-invoices-payment/selected-invoices-payment.tsx";

type PaymentModalBodyProps = {
	isLumpSumPayment: boolean;
	setAmounts: (amounts: number) => void;
	columns: GridColumnProps[];
	select: Invoice[];
	effectiveAmount: number;
	onAmountChange: (invoiceId: string, amount: number) => void;
	onDeleteInvoice: (invoiceId: string) => void;
};

export function PaymentModalBody({
	isLumpSumPayment,
	setAmounts,
	columns,
	select,
	effectiveAmount,
	onAmountChange,
	onDeleteInvoice,
}: Readonly<PaymentModalBodyProps>) {
	const { summary } = useGetPaymentSummary();
	if (isLumpSumPayment) {
		return (
			<LumpSumPayment
				amount={effectiveAmount}
				onAmountChange={setAmounts}
				outstandingBalance={summary?.outstandingBalance.sum}
			/>
		);
	}

	return (
		<SelectedInvoicesPayment
			columns={columns}
			invoices={select}
			onAmountChange={onAmountChange}
			onDeleteInvoice={onDeleteInvoice}
			totalPayment={effectiveAmount}
		/>
	);
}
